import React, { useState, useEffect } from 'react';
import { dropdowns, textinputs, forms } from 'seal-ui-components';
import styled from 'styled-components';
import style from './MultiSelectDropdown.style';

const { Select, SelectOption } = dropdowns;
const { Search } = textinputs;

const MultiSelectDropdown = ({ key, name, searchBox, options, setOptions, className, rest }) => {
    const [checkAll, setCheckAll] = useState(false);
    const [value, setValue] = useState([]);
    const [filterValue, setFilterValue] = useState('');

    useEffect(
        () => {
            setCheckAll(true);
            setValue(
                Object.values(options)
                    .filter(opt => opt.selected)
                    .map(opt => opt.text)
            );
            options && Object.values(options).map(opt => !opt.selected && setCheckAll(false));
        },
        [options]
    );

    const handleChange = (values, e) => {
        const tempItems = options;

        if (values.length > 0) {
            const selectedValue = e.currentTarget.title;
            tempItems[selectedValue].selected = !options[selectedValue].selected;
        } else {
            Object.keys(tempItems).forEach(k => (tempItems[k].selected = false));
        }
        setValue(values);
        setOptions({ ...tempItems });
    };

    const checkAllBoxOnChange = () => {
        const tempItems = { ...options };

        tempItems &&
            Object.keys(tempItems).forEach(k => {
                tempItems[k] = { ...options[k] };
                tempItems[k].selected = !checkAll;
            });

        setOptions({ ...tempItems });
        setValue(checkAll ? [] : Object.keys(options));
        return setCheckAll(!checkAll);
    };

    const toggleAllCheckbox = (
        <forms.CheckboxField
            key={`${name}_select-all`}
            data-testid={`${name}_dropdown_check_all_label`}
            label={'All'}
            checked={checkAll}
            onChange={checkAllBoxOnChange}
        />
    );

    const filteredOptions = filterValue
        ? Object.keys(options).filter(opt => opt.toUpperCase().includes(filterValue))
        : Object.keys(options);

    const selectOptions = filteredOptions.map(opt => (
        <SelectOption key={opt} value={opt} title={opt}>
            {opt}
        </SelectOption>
    ));

    const handleSearchChange = e => {
        setFilterValue(e.target.value.toUpperCase());
    };

    return (
        <div className={className}>
            <Select
                key={key}
                value={value}
                placeholder={`Select ${name}`}
                multiple={true}
                paddedMenu={false}
                shortenText={true}
                maxOptionsWidth={'2rem'}
                size="large"
                appearance="secondary"
                optionsTextSize="small"
                onChange={handleChange}
                {...rest}
            >
                {toggleAllCheckbox}
                {searchBox && (
                    <Search
                        value={filterValue}
                        placeholder={`Filter by ${name}`}
                        onChange={handleSearchChange}
                    />
                )}
                {selectOptions}
            </Select>
        </div>
    );
};

export default styled(MultiSelectDropdown)`
    ${style};
`;
